import { type ReactNode, type RefObject } from 'react';
import { useMedia } from 'react-use';
import { BreakpointQueryLarge } from '../../../main';
import { Modal } from '../Modal/Modal';
import { Sheet } from '../Sheet/Sheet';

interface Props {
  children: ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  innerContentClassName?: string;
  onDismiss: () => void;
  ariaLabel: string;
  testid?: string;
  isOpen: boolean;
  contentBodyClassName?: string;
  swipeCloseSegmentEvent?: () => void;
  showTouchBar?: boolean;
  isSmallModal?: boolean;
  height?: 'auto' | 'full';
  initialFocusRef?: RefObject<HTMLElement>;
  /**
   * When true, disables pointer events during the leave animation to prevent
   * clicks on closing modal content. Useful for nested modals on mobile.
   */
  disablePointerEventsOnClose?: boolean;
}

export function SheetOrModal(props: Props) {
  const {
    isOpen,
    children,
    testid,
    ariaLabel,
    onDismiss,
    contentClassName,
    contentBodyClassName,
    overlayClassName,
    swipeCloseSegmentEvent,
    innerContentClassName,
    showTouchBar,
    isSmallModal = false,
    height = 'auto',
    initialFocusRef,
    disablePointerEventsOnClose,
  } = props;
  const isDesktop = useMedia(BreakpointQueryLarge, false);

  if (isDesktop === true || isSmallModal) {
    return (
      <Modal
        contentClassName={contentClassName}
        overlayClassName={overlayClassName}
        innerContentClassName={innerContentClassName}
        onDismiss={onDismiss}
        ariaLabel={ariaLabel}
        testid={testid}
        isOpen={isOpen}
        initialFocusRef={initialFocusRef}
        disablePointerEventsOnClose={disablePointerEventsOnClose}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Sheet
      contentClassName={contentClassName}
      className={overlayClassName}
      initialFocusRef={initialFocusRef}
      onRequestDismiss={onDismiss}
      ariaLabel={ariaLabel}
      testid={testid}
      active={isOpen}
      contentBodyClassName={contentBodyClassName}
      swipeCloseSegmentEvent={swipeCloseSegmentEvent}
      showTouchBar={showTouchBar}
      height={height}
    >
      {children}
    </Sheet>
  );
}
